/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



import AssignDropdown from 'components/conversation/AssignDropdown'
import DropDown from 'components/DropDown'

import styles from './style'

const SendFromEdit = React.createClass({
  mixins: [require('react-onclickoutside')],

  getInitialState() { return { showDropdown: false } },

  handleClickOutside() {
    return this.setState({ showDropdown: false })
  },

  handleOnClick() {
    return this.setState({ showDropdown: !this.state.showDropdown })
  },

  renderDropDown() {
    return (
      <DropDown className="assign-dropdown" onClickOutside={this.handleClickOutside}>
        <AssignDropdown
          handleUserRowOnClick={this.onSenderSelect}
          assignee={this.props.user}
          calendarUsersOnly={this.props.calendarUsersOnly} />
      </DropDown>
    )
  },

  onSenderSelect(userId) {
    this.setState({ showDropdown: false })
    return this.props.onSenderSelect(userId)
  },

  clearSender(event) {
    return this.props.onSenderSelect(null)
  },

  render() {
    return (
      <div className={styles.SendFromEdit}>
        <div className="link" onClick={this.handleOnClick}>
          {this.props.user ? 'Edit' : 'Add'}
        </div>
        {this.props.enableClear && this.props.user ?
          <div className="link" onClick={this.clearSender}>
            Clear
          </div> : undefined}
        {this.state.showDropdown ? this.renderDropDown() : undefined}
      </div>
    )
  }
})

export default SendFromEdit



// WEBPACK FOOTER //
// ./src/scripts/components/shared/SendFromEdit/index.js